import React, { useState, useEffect } from 'react'
import axios from 'axios'

export const AuthContext = React.createContext({
    isAuth: false,
})

const AuthContextProvider = props => {
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [isInitialized, setIsInitialized] = useState(false)
    const [loading, setLoading] = useState(false)

    const logOuthandler = () => {
        localStorage.removeItem('pulsarBotPlatform_operatorToken')
        localStorage.removeItem('pulsarBotPlatform_operatorUsername')
        localStorage.removeItem('pulsarBotPlatform_operatorLastConvo')

        setIsAuthenticated(false)
    }

    const logInHandler = () => {
        const authorization = localStorage.getItem(
            'pulsarBotPlatform_operatorToken'
        )
        setLoading(true)
        axios({
            url: '/api/operators/check-user-exists',
            method: 'GET',
            headers: { authorization },
        })
            .then(() => {
                console.log('#### SUCCESS ####')
                setLoading(false)
                setIsAuthenticated(true)
            })
            .catch(() => {
                console.log('#### FAIL ####')
                setLoading(false)
                logOuthandler()
            })
    }

    useEffect(() => {
        const token = localStorage.getItem('pulsarBotPlatform_operatorToken')

        if (token) {
            logInHandler()
        }

        setIsInitialized(true)
    }, [])

    return (
        <AuthContext.Provider
            value={{
                login: logInHandler,
                logout: logOuthandler,
                isAuth: isAuthenticated,
                isInit: isInitialized,
                checkUserLoading: loading,
            }}
        >
            {props.children}
        </AuthContext.Provider>
    )
}

export default AuthContextProvider
